/**************************************************
 * Nombre:       Dialogo_Funnel_Dos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {usePestanasFormularios} from "../../../Modulo_CRM/Hooks/usePestanasFormularios";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Estado from "../../Formularios/Funnels/Formulario_Estado";
import Formulario_Datos from "../../Formularios/Funnels/Formulario_Datos";
import {Delete} from "@mui/icons-material";
import {subirImagenHostingFile} from "../../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {borrarDoc} from "../../../Servicios/BD/borrarDoc";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../../Recursos/logo_redondo.svg";
import Formulario_Video_Uno from "../../Formularios/Funnels/Formulario_Video_Uno";
import {subirImgArrObjetos} from "../../../Servicios/AlmacenamientoHosting/subirImgArrObjetos";
import Formulario_Estadisticas from "../../Formularios/Funnels/Formulario_Estadisticas";
import Formulario_Datos_Pasos from "../../Formularios/Funnels/Formulario_Datos_Pasos";
import Formulario_Datos_Preguntas from "../../Formularios/Funnels/Formulario_Datos_Preguntas";

const Dialogo_Funnel_Dos = ({datos, realizado, cerrar}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Pestanas} = usePestanasFormularios(
        {
            pestanas: ['Datos', 'Estadisticas', 'Pasos', 'Preguntas'],
            Formularios: [
                <Formulario_Datos props={props}/>,
                <Formulario_Estadisticas props={props}/>,
                <Formulario_Datos_Pasos props={props}/>,
                <Formulario_Datos_Preguntas props={props}/>,
            ]
        }
    )
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')

        let resultado = await subirImagenHostingFile(entidad.img)
        entidad.img = resultado.data


        let pasos = await subirImgArrObjetos({arr: entidad.pasos, propiedad: 'img'})
        entidad.pasos = pasos

        nuevoAviso({aviso: 'Imagen subida'})


        let dox = await guardarDoc('funnels', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('funnels', datos.id)
        terminar({aviso: 'Funnel borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Estado props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Pestanas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }

        </Grid>
    )

}
export default Dialogo_Funnel_Dos